import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDoc = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M24.1016 2C25.2969 2 26.4219 2.49219 27.2656 3.33594L33.6641 9.73438C34.5078 10.5781 35 11.7031 35 12.8984V33.5C35 36.0312 32.9609 38 30.5 38H9.5C6.96875 38 5 36.0312 5 33.5V6.5C5 4.03906 6.96875 2 9.5 2H24.1016ZM9.5 5.375C8.86719 5.375 8.375 5.9375 8.375 6.5V33.5C8.375 34.1328 8.86719 34.625 9.5 34.625H30.5C31.0625 34.625 31.625 34.1328 31.625 33.5V13.25H26C24.7344 13.25 23.75 12.2656 23.75 11V5.375H9.5Z" })
});
export default SvgDoc;
